var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtremeTemperatureAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 34,
    viewBox: "0 0 21 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    className: "p-stroke",
    d: "M13.3235 21.2639V21.6834L13.6687 21.9219C14.7248 22.652 15.5308 23.7175 15.9622 24.9647C16.3936 26.2121 16.426 27.5711 16.0541 28.8395C15.6822 30.1076 14.9274 31.2134 13.9064 31.9968C12.8859 32.7797 11.6527 33.2 10.389 33.2C9.12524 33.2 7.89201 32.7797 6.87149 31.9968C5.85051 31.2134 5.09571 30.1076 4.72387 28.8395C4.35195 27.5711 4.3843 26.2121 4.81578 24.9647C5.24718 23.7175 6.0531 22.652 7.10927 21.9219L7.4544 21.6834V21.2639V3.86335C7.4544 3.04231 7.76994 2.26013 8.32342 1.68757C8.87601 1.11592 9.61959 0.8 10.389 0.8C11.1583 0.8 11.9019 1.11592 12.4545 1.68757C13.008 2.26013 13.3235 3.04231 13.3235 3.86335V21.2639Z",
    stroke: "black",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "p-fill",
    d: "M17.1863 8.96848H20.2063C20.5846 8.96848 20.8926 8.65179 20.8926 8.2618C20.8926 7.87265 20.5846 7.55554 20.2063 7.55554H17.1863C16.808 7.55554 16.5 7.87265 16.5 8.2618C16.5 8.65179 16.808 8.96848 17.1863 8.96848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p-fill",
    d: "M17.1863 5.19065H20.2063C20.5846 5.19065 20.8926 4.87396 20.8926 4.48397C20.8926 4.09481 20.5846 3.77771 20.2063 3.77771H17.1863C16.808 3.77771 16.5 4.09481 16.5 4.48397C16.5 4.87396 16.808 5.19065 17.1863 5.19065Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p-fill",
    d: "M20.2061 15.0336H17.1862C16.8078 15.0336 16.5002 15.3507 16.5002 15.7402C16.5002 16.1298 16.8078 16.4465 17.1862 16.4465H20.2061C20.5845 16.4465 20.8925 16.1298 20.8925 15.7402C20.8925 15.3507 20.5845 15.0336 20.2061 15.0336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p-fill",
    d: "M17.1862 11.2946C16.8078 11.2946 16.5002 11.6117 16.5002 12.0012C16.5002 12.3908 16.8078 12.7075 17.1862 12.7075H20.2061C20.5845 12.7075 20.8925 12.3908 20.8925 12.0012C20.8925 11.6117 20.5845 11.2946 20.2061 11.2946H17.1862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p-stroke",
    d: "M10.3889 25.8148L10.3889 4.40741",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtremeTemperatureAlert);
export default __webpack_public_path__ + "static/media/ExtremeTemperatureAlert.f1730a4a4c8ab593c8cb12f86b721618.svg";
export { ForwardRef as ReactComponent };